var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBtnIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3931 37.9738C24.9753 36.365 21.2078 32.3953 21.6241 30.1155C22.1443 27.2658 24.8441 27.2658 25.8847 27.7839C26.717 28.1984 28.4687 30.0759 29.2545 31.0654C29.8367 30.2796 31.4744 28.1294 32.723 27.7839C34.2838 27.3521 37.8389 28.2157 36.7983 31.929C35.966 34.8996 31.7692 38.9237 31.7692 38.9237L25.1792 44.9686C25.1792 44.9686 21.6524 41.1196 19.7164 38.4056C16.9505 34.5284 15.5633 32.7061 13.7333 27.7839C10.3574 18.7028 12.9531 3 12.9531 3C12.9531 3 13.7334 12.499 14.6872 16.0396C15.6161 19.4876 17.5487 21.9981 20.8437 22.6026C24.1387 23.2071 28.5205 21.3687 28.9077 24.5888C28.988 25.2571 28.8648 25.9806 28.6534 26.6073C28.442 27.2341 27.4935 28.2861 27.4935 28.2861",
    stroke: "url(#paint0_linear_389_2111)",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3836 38.0052C24.9657 36.3964 21.1983 32.4266 21.6144 30.1469C22.1347 27.2971 24.8345 27.2971 25.8751 27.8152C26.7075 28.2298 28.4591 30.1072 29.245 31.0968C29.8271 30.3109 31.4648 28.1607 32.7134 27.8152C34.2742 27.3835 37.8293 28.247 36.7888 31.9603C35.9564 34.9309 31.7596 38.9551 31.7596 38.9551L25.1696 44.9999",
    stroke: "url(#paint1_linear_389_2111)",
    strokeWidth: 1.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2254 14.6141C27.2254 16.716 25.5214 18.42 23.4195 18.42C21.3175 18.42 19.6135 16.716 19.6135 14.6141C19.6135 12.5121 21.3175 10.8081 23.4195 10.8081C25.5214 10.8081 27.2254 12.5121 27.2254 14.6141Z",
    stroke: "#0593A1",
    strokeWidth: 1.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_389_2111",
    x1: 24.493,
    y1: 3,
    x2: 32.2999,
    y2: 64.5998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D9B571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_389_2111",
    x1: 32.3895,
    y1: 27.5518,
    x2: 25.01,
    y2: 46.0879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0593A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934359,
    stopColor: "#0593A1",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBtnIcon);
export default __webpack_public_path__ + "static/media/login_btn_icon.942126b65e823ba65c751e6b8765dccc.svg";
export { ForwardRef as ReactComponent };